module.exports = __webpack_public_path__ + "media/img/pages/profile/migros ger 3-3939488fdb479a48b29498f779f3417d.jpg";